if (!customElements.get('subscription-upsell-drawer')) {

  // Create a global flag to prevent the drawer from re-opening
  window.bypassUpsellDrawer = false;

  customElements.define(
    'subscription-upsell-drawer',
    class SubscriptionUpsellDrawer extends HTMLElement {
      constructor() {
        super();
        this.originalProductForm = null;
        this.currentFormData = null;
        this.productVariantsData = [];
        this.offersData = null;
        
        const variantsJsonScript = this.querySelector('script#upsell-drawer-variants-json');
        if (variantsJsonScript) {
          try {
            this.productVariantsData = JSON.parse(variantsJsonScript.textContent);
          } catch (e) {
            console.error('Error parsing product variants JSON from script tag:', e);
            this.productVariantsData = [];
          }
        } else {
          console.warn('Upsell drawer: Variants JSON script tag not found.');
        }

        const offersJsonScript = this.querySelector('script#upsell-drawer-offers-json');
        if (offersJsonScript) {
          try {
            this.offersData = JSON.parse(offersJsonScript.textContent);
          } catch (e) {
            console.error('Error parsing offers JSON from script tag:', e);
            this.offersData = null;
          }
        } else {
          console.warn('Upsell drawer: Offers JSON script tag not found.');
        }

        this.subscribeButton = this.querySelector('[data-subscribe-button]');
        this.subscribeButtonTextDefault = this.subscribeButton ? this.subscribeButton.innerHTML : '';

        this.drawerTitleElement = this.querySelector('[data-upsell-drawer-title]');
        this.drawerTitleDefaultText = this.drawerTitleElement ? this.drawerTitleElement.textContent : 'Subscribe & Save'; 

        this.drawerTitleBase = this.drawerTitleDefaultText.replace(/{{.*percentage_off.*}}%?/i, '').trim();
        if (this.drawerTitleDefaultText.toLowerCase().includes('save 0%')) { 
            this.drawerTitleBase = this.drawerTitleDefaultText.replace(/0%/, '').trim();
        }

        this.bindSubscriptionEvents();
        this.addEventListener('click', (event) => {
          if (event.target.classList.contains('upsell-drawer__overlay')) {
            event.preventDefault();
            event.stopPropagation();
            this.closeUpsellDrawer();
          }
        });
      }

      connectedCallback() {
        const overlay = this.querySelector('.upsell-drawer__overlay');
        if (overlay) {
          overlay.addEventListener('click', (e) => {
            e.stopPropagation();
            this.closeUpsellDrawer();
          });
        }
      }

      bindSubscriptionEvents() {
        const continueBtn = this.querySelector('[data-continue-onetime]');
        if (continueBtn) {
          continueBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.continueWithOneTime();
          });
        } 

        const subscribeBtn = this.querySelector('[data-subscribe-button]');
        if (subscribeBtn) {
          subscribeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.switchToSubscription();
          });
        }

        const closeBtn = this.querySelector('.upsell-drawer__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', this.closeUpsellDrawer.bind(this));
        }
      }

      open(productForm, formData) {
        if (window.bypassUpsellDrawer) {
          window.bypassUpsellDrawer = false;
          return false;
        }
        
        this.originalProductForm = productForm;
        this.currentFormData = formData;

        const selectedVariantId = this.currentFormData ? String(this.currentFormData.get('id')) : null;
        const priceElement = this.querySelector('[data-upsell-drawer-product-price]');

        if (selectedVariantId && priceElement && this.productVariantsData.length > 0) {
          const selectedVariantData = this.productVariantsData.find(v => String(v.id) === selectedVariantId);
          if (selectedVariantData && selectedVariantData.formatted_price) {
            priceElement.textContent = selectedVariantData.formatted_price;
          } else if (selectedVariantData && typeof selectedVariantData.price === 'number') {
            priceElement.textContent = `$${(selectedVariantData.price / 100).toFixed(2)}`; 
          }
        } else if (priceElement) {
          console.warn('Upsell drawer: Could not determine selected variant ID or productVariantsData is empty for price update.');
        }
        
        // Dynamically calculate and update discount for the subscribe button
        if (this.offersData && selectedVariantId && this.subscribeButton) {
          const oneTimeOfferId = this.offersData.onetime ? this.offersData.onetime[0] : null;
          const recurringOfferId = this.offersData.recurring ? this.offersData.recurring[0] : null;

          if (oneTimeOfferId && recurringOfferId && this.offersData.data) {
            const oneTimeOffer = this.offersData.data[oneTimeOfferId];
            const recurringOffer = this.offersData.data[recurringOfferId];

            let oneTimePriceForVariant = oneTimeOffer.price;
            if (oneTimeOffer.variant_prices && oneTimeOffer.variant_prices[selectedVariantId]) {
              oneTimePriceForVariant = oneTimeOffer.variant_prices[selectedVariantId];
            }

            let recurringPriceForVariant = recurringOffer.price;
            if (recurringOffer.variant_prices && recurringOffer.variant_prices[selectedVariantId]) {
              recurringPriceForVariant = recurringOffer.variant_prices[selectedVariantId];
            }
            
            oneTimePriceForVariant = parseFloat(oneTimePriceForVariant);
            recurringPriceForVariant = parseFloat(recurringPriceForVariant);

            let discountPercentage = 0;
            if (oneTimePriceForVariant > 0 && recurringPriceForVariant < oneTimePriceForVariant) {
              const discountValue = oneTimePriceForVariant - recurringPriceForVariant;
              discountPercentage = Math.round((discountValue / oneTimePriceForVariant) * 100);
            }

            const tKey = 'products.product.subscription_upsell_drawer.subscribe_button_label';
            let buttonText = this.subscribeButtonTextDefault; 

            if (discountPercentage > 0) {
                buttonText = `Subscribe & Save ${discountPercentage}%`; 
            } else {
                buttonText = 'Subscribe'; 
            }
            this.subscribeButton.innerHTML = buttonText; 

            if (this.drawerTitleElement) {
              let titleText = this.drawerTitleBase;
              if (discountPercentage > 0) {

                titleText = `${this.drawerTitleBase} ${discountPercentage}%`;
              } else {
                titleText = this.drawerTitleBase || 'Upgrade to Subscription'; 
              }
              this.drawerTitleElement.textContent = titleText;
            }

          } else {
            this.subscribeButton.innerHTML = this.subscribeButtonTextDefault; 
            if (this.drawerTitleElement) {
              this.drawerTitleElement.textContent = this.drawerTitleDefaultText; 
            }
          }
        } else if (this.subscribeButton) {
          this.subscribeButton.innerHTML = this.subscribeButtonTextDefault; 
          if (this.drawerTitleElement) {
            this.drawerTitleElement.textContent = this.drawerTitleDefaultText; 
          }
        }
        
        this.classList.add('active');
        document.body.classList.add('upsell-drawer-open');
        
        this.documentClickHandler = this.handleDocumentClick.bind(this);
        setTimeout(() => {
          document.addEventListener('click', this.documentClickHandler);
        }, 100);
        
        const overlay = this.querySelector('.upsell-drawer__overlay');
        if (overlay) {
          overlay.style.pointerEvents = 'auto';
        }

        const innerElement = this.querySelector('.upsell-drawer__inner');
        if (innerElement) {
          innerElement.style.transform = 'translateX(0)';
        }
        
        return false;
      }

      handleDocumentClick(event) {
        if (!this.classList.contains('active')) return;
        
        const innerElement = this.querySelector('.upsell-drawer__inner');
        
        if (innerElement && 
            !innerElement.contains(event.target) && 
            !event.target.closest('product-form button[name="add"]')) {
          this.closeUpsellDrawer();
        }
      }

      closeUpsellDrawer() {
        if (this.documentClickHandler) {
          document.removeEventListener('click', this.documentClickHandler);
        }
        
        this.classList.remove('active');
        document.body.classList.remove('upsell-drawer-open');
        
        const innerElement = this.querySelector('.upsell-drawer__inner');
        if (innerElement) {
          innerElement.style.transform = 'translateX(100%)';
        }
        
        if (this.originalProductForm && this.originalProductForm.submitButton) {
          this.originalProductForm.submitButton.removeAttribute('aria-disabled');
          this.originalProductForm.submitButton.classList.remove('loading');
          const spinner = this.originalProductForm.querySelector('.loading__spinner');
          if (spinner) {
            spinner.classList.add('hidden');
          }
        }
      }

      continueWithOneTime() {
        this.closeUpsellDrawer();
        
        // Just show the cart drawer since item is already added
        this.openCartDrawerWithFreshData();
      }

      switchToSubscription() {
        this.closeUpsellDrawer();

        if (!this.currentFormData || !this.currentFormData.has('id')) {
          console.error('Original form data (currentFormData) or its product variant ID is missing. Cannot switch to subscription.');
          if (this.originalProductForm && this.originalProductForm.submitButton) {
              this.originalProductForm.submitButton.removeAttribute('aria-disabled');
              this.originalProductForm.submitButton.classList.remove('loading');
              const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
          }
          return;
        }

        // First, remove the one-time item from cart, then add subscription
        this.removeOneTimeAndAddSubscription();
      }

      removeOneTimeAndAddSubscription() {
        if (this.originalProductForm && this.originalProductForm.submitButton) {
          this.originalProductForm.submitButton.setAttribute('aria-disabled', true);
          this.originalProductForm.submitButton.classList.add('loading');
          const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        const shopifyProductVariantId = this.currentFormData.get('id');
        const quantity = this.currentFormData.get('quantity') || '1';

        // Step 1: Remove the one-time item from cart
        const removeData = new FormData();
        removeData.append('id', shopifyProductVariantId);
        removeData.append('quantity', '0'); // Setting quantity to 0 removes the item
        removeData.append('sections', 'cart-drawer,cart-icon-bubble');
        removeData.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: removeData
        })
        .then(response => response.json())
        .then(data => {
          // Step 2: Add subscription item
          this.addSubscriptionToCart();
        })
        .catch(error => {
          console.error('Error removing one-time item:', error);
          // Still try to add subscription even if removal fails
          this.addSubscriptionToCart();
        });
      }

      addSubscriptionToCart() {
        const shopifyProductVariantId = this.currentFormData.get('id');
        const quantity = this.currentFormData.get('quantity') || '1';

        const formDataForSubscription = new FormData();
        formDataForSubscription.set('id', shopifyProductVariantId);
        formDataForSubscription.set('quantity', quantity);

        for (const [key, value] of this.currentFormData.entries()) {
          if (key !== 'id' && key !== 'quantity' && !key.startsWith('properties[') && key !== 'sections' && key !== 'sections_url') {
            formDataForSubscription.append(key, value);
          }
        }

        const subscriptionRadio = document.querySelector('.onetime-purchase input[data-type="subscription"]');
        const subscriptionSelect = document.querySelector('.onetime-purchase .onetime-purchase__select');
        
        let offerProperties = {};
        let determinedOfferId = null;

        if (subscriptionRadio) {
          let baseOfferId = subscriptionRadio.dataset.offerId;
          let baseOfferName = subscriptionRadio.dataset.offerName;
          let baseOfferPrice = subscriptionRadio.dataset.offerPrice; 
          let shippingIntervalFrequency = '30';

          if (subscriptionSelect && subscriptionSelect.options.length > 0 && subscriptionSelect.value) {
            const selectedOption = subscriptionSelect.options[subscriptionSelect.selectedIndex];
            shippingIntervalFrequency = selectedOption.value; 
            
            determinedOfferId = selectedOption.dataset.offerId || baseOfferId;
            offerProperties['_offer_name'] = selectedOption.dataset.offerName || baseOfferName;
            offerProperties['_offer_price'] = selectedOption.dataset.offerPrice || baseOfferPrice;
          } else {
            determinedOfferId = baseOfferId;
            offerProperties['_offer_name'] = baseOfferName;
            offerProperties['_offer_price'] = baseOfferPrice;
          }
          
          offerProperties['_offer_id'] = determinedOfferId;
          offerProperties['_shipping_interval_frequency'] = shippingIntervalFrequency;
          offerProperties['_subscription_type'] = 'subscription';

        } else {
           console.error('Subscription radio button not found on the page. Cannot determine subscription details.');
           if (this.originalProductForm && this.originalProductForm.submitButton) {
             this.originalProductForm.submitButton.removeAttribute('aria-disabled');
             this.originalProductForm.submitButton.classList.remove('loading');
             const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
             if (spinner) spinner.classList.add('hidden');
           }
           return; 
        }

        if (!determinedOfferId) {
          console.error('Could not determine the subscription offer ID.');
          if (this.originalProductForm && this.originalProductForm.submitButton) {
            this.originalProductForm.submitButton.removeAttribute('aria-disabled');
            this.originalProductForm.submitButton.classList.remove('loading');
             const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
          return;
        }
        
        for (const key in offerProperties) {
            formDataForSubscription.set(`properties[${key}]`, offerProperties[key]);
        }

        this.submitDirectToCart(formDataForSubscription);
      }

      submitDirectToCart(formData) {
        if (this.originalProductForm && this.originalProductForm.submitButton) {
          this.originalProductForm.submitButton.setAttribute('aria-disabled', true);
          this.originalProductForm.submitButton.classList.add('loading');
          const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }
        
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        })
        .then(response => {
           if (!response.ok) {
              return response.json().catch(() => {
                 throw new Error(`HTTP error ${response.status}: ${response.statusText}`); 
              }).then(errorData => {
                 throw new Error(errorData.description || `HTTP error ${response.status}`);
              });
           }
           return response.json(); 
        })
        .then(data => {
          if (data.status && data.status !== 200) { 
            console.error('Error adding to cart:', data.description || data.message);
            if (this.originalProductForm && this.originalProductForm.handleErrorMessage) {
              this.originalProductForm.handleErrorMessage(data.description || data.message);
            }
            return; 
          }
          
          this.updateCartUI(data);
        })
        .catch(error => {
          console.error('Error submitting form:', error.message || error);
          window.bypassUpsellDrawer = false;
          if (this.originalProductForm && this.originalProductForm.handleErrorMessage) {
            this.originalProductForm.handleErrorMessage('Could not add item to cart. Please try again.'); 
          }
        })
        .finally(() => {
          if (this.originalProductForm && this.originalProductForm.submitButton) {
            this.originalProductForm.submitButton.removeAttribute('aria-disabled');
            this.originalProductForm.submitButton.classList.remove('loading');
            const spinner = this.originalProductForm.submitButton.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        });
      }

      openCartDrawerWithFreshData() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
          window.location.href = window.routes.cart_url;
          return;
        }
        
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currentDrawer = document.getElementById('CartDrawer');
            const sourceDrawer = html.getElementById('CartDrawer');
            const currentInner = currentDrawer ? currentDrawer.querySelector('.drawer__inner') : null;
            const sourceInner = sourceDrawer ? sourceDrawer.querySelector('.drawer__inner') : null;
            if (currentInner && sourceInner) {
              currentInner.innerHTML = sourceInner.innerHTML;
            } else {
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
            }
            
            this.updateCartIcon();
            
            try {
              cartDrawer.classList.remove('is-empty');
              if (typeof window.checkAndAddProtectPlus === 'function') {
                window.checkAndAddProtectPlus();
              } else if (typeof window.addProtectPlusToCart === 'function') {
                window.addProtectPlusToCart();
              }
              if (typeof window.attachEventHandlers === 'function') {
                window.attachEventHandlers();
              }
              if (typeof window.updateDisclaimerVisibility === 'function') {
                window.updateDisclaimerVisibility();
              }
            } catch (hookError) {
              console.error('Error running cart drawer post-refresh hooks:', hookError);
            }

            cartDrawer.open();
          })
          .catch((e) => {
            console.error('Error fetching cart drawer:', e);
            cartDrawer.open();
          });
      }

      updateCartIcon() {
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((responseText) => {
            const cartIcon = document.querySelector('#cart-icon-bubble');
            if (cartIcon) {
              cartIcon.innerHTML = responseText;
            }
          })
          .catch((e) => {
            console.error('Error updating cart icon:', e);
          });
      }

      updateCartDrawerManually(sectionsData) {
        // Update cart icon
        if (sectionsData['cart-icon-bubble']) {
          const iconBubbleContainer = document.querySelector('#shopify-section-cart-icon-bubble');
          if (iconBubbleContainer) {
            iconBubbleContainer.innerHTML = sectionsData['cart-icon-bubble'];
          }
        }
        
        // Update cart drawer content
        if (sectionsData['cart-drawer']) {
          const cartDrawer = document.querySelector('cart-drawer');
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = sectionsData['cart-drawer'];
            const newDrawerInner = tempDiv.querySelector('.drawer__inner');
            
            if (newDrawerInner) {
              drawerInner.innerHTML = newDrawerInner.innerHTML;
            }
          }
        }
      }
      
      updateCartUI(data) {
        window.bypassUpsellDrawer = false;
        
        if (data.sections && data.sections['cart-icon-bubble']) {
          const iconBubbleContainer = document.querySelector('#shopify-section-cart-icon-bubble');
          if (iconBubbleContainer) {
            iconBubbleContainer.innerHTML = data.sections['cart-icon-bubble'];
          }
        }
        
        const cartDrawerComponent = document.querySelector('cart-drawer');

        if (cartDrawerComponent) {
            if (typeof cartDrawerComponent.renderContents === 'function') {
              cartDrawerComponent.renderContents(data);
              setTimeout(() => {
                if (cartDrawerComponent.classList.contains('is-empty')) {
                  cartDrawerComponent.classList.remove('is-empty');
                }
                if (!cartDrawerComponent.classList.contains('active')) {
                    cartDrawerComponent.classList.add('active', 'animate');
                    document.body.classList.add('overflow-hidden');
                    if (typeof cartDrawerComponent.open === 'function') {
                        try {
                            cartDrawerComponent.open();
                        } catch (e) {
                            console.error('Error calling cart drawer open method after renderContents:', e);
                        }
                    }
                }
              }, 50);
            } else if (data.sections && data.sections['cart-drawer']) {
              const drawerInner = cartDrawerComponent.querySelector('.drawer__inner');
              if (drawerInner) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data.sections['cart-drawer'];
                const newDrawerInner = tempDiv.querySelector('.drawer__inner');
                
                if (newDrawerInner) {
                  drawerInner.innerHTML = newDrawerInner.innerHTML;
                  
                  setTimeout(() => {
                    cartDrawerComponent.classList.add('active', 'animate');
                    if (cartDrawerComponent.classList.contains('is-empty')) {
                      cartDrawerComponent.classList.remove('is-empty');
                    }
                    document.body.classList.add('overflow-hidden');
                    if (typeof cartDrawerComponent.open === 'function') {
                      try {
                        cartDrawerComponent.open();
                      } catch (e) {
                        console.error('Error calling cart drawer open method:', e);
                      }
                    }
                  }, 100);
                }
              }
            } else if (cartDrawerComponent) {
              this.fetchCartDrawer();
            }
        } else {
          window.location.href = window.routes.cart_url;
        }
      }
      
      fetchCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
          window.location.href = window.routes.cart_url;
          return;
        }
        
        fetch(`${window.routes.cart_url}?view=drawer`)
          .then(response => response.text())
          .then(html => {
            try {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;
              
              const newDrawerInner = tempDiv.querySelector('.drawer__inner');
              const currentDrawerInner = cartDrawer.querySelector('.drawer__inner');
              
              if (newDrawerInner && currentDrawerInner) {
                currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
              }
              
              cartDrawer.classList.add('active', 'animate');
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
              document.body.classList.add('overflow-hidden');
              if (typeof cartDrawer.open === 'function') {
                try {
                  cartDrawer.open();
                } catch (e) {
                  console.error('Error calling cart drawer open method in fetchCartDrawer:', e);
                }
              }
            } catch (e) {
              console.error('Error updating cart drawer:', e);
              window.location.reload();
            }
          })
          .catch(error => {
            console.error('Error fetching cart drawer:', error);
            window.location.reload();
          });
      }
    }
  );
}